import { createFileRoute } from '@tanstack/react-router'
import { DocumentoAnalise } from '@/features/documentos/analise'
import { requireAtestadosAccess } from '@/lib/route-guards'

export const Route = createFileRoute(
  '/_authenticated/documentos/$collection/$id',
)({
  beforeLoad: async () => {
    await requireAtestadosAccess()
  },
  component: DocumentoAnalise,
})
